import React from 'react';
import { Box, Container, Typography, Grid } from '@mui/material';
import { useLocation } from 'react-router-dom';
import { Page1 } from './skinpage/Page1';
import { Footer } from '../components/Footer';
import { Page5 } from './skinpage/Page5';
import Page3 from './skinpage/Page3';

const SkinPage: React.FC = () => {
    const location = useLocation();
    const isLArcPage = location.pathname === '/skin/larc';

    // L'A Products Component
    const LArcProducts = () => (
        <Container maxWidth={false} sx={{ padding: '40px 20px', backgroundColor: '#f8f9fa' }}>
            <Box sx={{
                backgroundColor: 'rgba(138, 43, 226, 0.02)',
                borderRadius: '20px',
                padding: '40px',
                marginBottom: '40px',
                border: '1px solid rgba(138, 43, 226, 0.1)',
                textAlign: 'center'
            }}>
                <Typography
                    sx={{
                        fontFamily: 'ClaireMurphy',
                        fontSize: '32px',
                        fontWeight: 400,
                        color: 'rgba(138, 43, 226, 1)',
                        marginBottom: '20px',
                    }}
                >
                    L'ARC PROFESSIONAL
                </Typography>
                <Typography
                    sx={{
                        fontFamily: 'Quicksand',
                        fontSize: '18px',
                        fontWeight: 400,
                        color: 'rgba(136, 136, 136, 1)',
                        marginBottom: '40px',
                        maxWidth: '600px',
                        margin: '0 auto 40px',
                    }}
                >
                    Premium skincare solutions designed for professional results in the comfort of your home.
                </Typography>

                <Grid container spacing={4} justifyContent="center">
                    <Grid item xs={12} sm={6} md={4}>
                        <Box
                            sx={{
                                borderRadius: '36px',
                                border: '2px solid rgba(138, 43, 226, 0.3)',
                                overflow: 'hidden',
                                padding: '30px',
                                height: '100%',
                                display: 'flex',
                                flexDirection: 'column',
                                justifyContent: 'center',
                                alignItems: 'center',
                                backgroundColor: '#fff',
                                transition: 'transform 0.2s ease-in-out, box-shadow 0.2s ease-in-out',
                                '&:hover': {
                                    transform: 'translateY(-4px)',
                                    boxShadow: '0 8px 25px rgba(138, 43, 226, 0.2)',
                                },
                            }}
                        >
                            <Typography
                                sx={{
                                    fontFamily: 'Quicksand',
                                    fontSize: '24px',
                                    fontWeight: 600,
                                    color: 'rgba(138, 43, 226, 1)',
                                    marginBottom: '20px',
                                    textAlign: 'center',
                                    textTransform: 'uppercase',
                                }}
                            >
                                Coming Soon
                            </Typography>
                            <Typography
                                sx={{
                                    fontFamily: 'Quicksand',
                                    fontSize: '20px',
                                    fontWeight: 600,
                                    color: 'rgba(138, 43, 226, 1)',
                                    marginBottom: '10px',
                                    textAlign: 'center',
                                }}
                            >
                                L'A Gentle Foaming Cleanser
                            </Typography>
                            <Typography
                                sx={{
                                    fontFamily: 'Quicksand',
                                    fontSize: '16px',
                                    fontWeight: 400,
                                    color: 'rgba(136, 136, 136, 1)',
                                    marginBottom: '15px',
                                    textAlign: 'center',
                                }}
                            >

                            </Typography>
                            <Typography
                                sx={{
                                    fontFamily: 'Quicksand',
                                    fontSize: '18px',
                                    fontWeight: 600,
                                    color: 'rgba(61, 61, 61, 1)',
                                    marginBottom: '25px',
                                    textAlign: 'center',
                                }}
                            >
                                coming soon
                            </Typography>
                        </Box>
                    </Grid>
                </Grid>
            </Box>
        </Container>
    );

    return (
        <>
            <Page1 />

            {/* Content based on route */}
            {isLArcPage ? (
                <LArcProducts />
            ) : (
                <>
                    <Page5 />
                    <Page3 />
                </>
            )}

            <Footer />
        </>
    );
};

export default SkinPage;
